export default function ThankYouScreen({ name }) {
  return (
    <div className="flex h-screen items-center justify-center bg-surface-raised p-4 font-body">
      <div className="w-full max-w-[580px] rounded-lg bg-dark p-12 text-center shadow-card relative overflow-hidden">
        <span className="mb-4 block animate-bounce text-6xl">🎉</span>
        <h2 className="font-heading text-3xl font-extrabold text-white">
          Thank you <br/>
          <span className="text-primary">{name || 'for sharing!'}</span>
        </h2>
        <p className="mt-4 text-sm text-text-muted">
          Your feedback has been submitted. We appreciate your time.
        </p>
      </div>
    </div>
  );
}